var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.41379V9.05579C8 9.321 7.89464 9.57536 7.70711 9.76289C7.51957 9.95043 7.26522 10.0558 7 10.0558C6.73478 10.0558 6.48043 9.95043 6.29289 9.76289C6.10536 9.57536 6 9.321 6 9.05579V3.41379L4.879 4.53579C4.69123 4.72343 4.4366 4.82879 4.17115 4.8287C3.90569 4.8286 3.65114 4.72306 3.4635 4.53529C3.27586 4.34751 3.1705 4.09289 3.17059 3.82743C3.17068 3.56198 3.27623 3.30743 3.464 3.11979L6.293 0.292786C6.48053 0.105315 6.73484 0 7 0C7.26516 0 7.51947 0.105315 7.707 0.292786L10.536 3.12079C10.6289 3.21376 10.7026 3.32413 10.7529 3.44558C10.8031 3.56704 10.829 3.6972 10.8289 3.82864C10.8289 3.96008 10.8029 4.09023 10.7526 4.21164C10.7022 4.33306 10.6285 4.44338 10.5355 4.53629C10.4425 4.6292 10.3322 4.70288 10.2107 4.75314C10.0893 4.8034 9.95909 4.82924 9.82765 4.8292C9.69621 4.82915 9.56606 4.80321 9.44464 4.75287C9.32322 4.70253 9.21291 4.62876 9.12 4.53579L8 3.41379ZM1 11.9998H13C13.2652 11.9998 13.5196 12.1051 13.7071 12.2927C13.8946 12.4802 14 12.7346 14 12.9998C14 13.265 13.8946 13.5194 13.7071 13.7069C13.5196 13.8944 13.2652 13.9998 13 13.9998H1C0.734784 13.9998 0.48043 13.8944 0.292893 13.7069C0.105357 13.5194 0 13.265 0 12.9998C0 12.7346 0.105357 12.4802 0.292893 12.2927C0.48043 12.1051 0.734784 11.9998 1 11.9998Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.057816b2ccc2cf28d07fb29d3fd2fd30.svg";
export { ForwardRef as ReactComponent };